import axios from "axios";
import { AUTH_API } from "../common/constants";
import {
  AUTH_ERROR_CODE,
  IForgotPasswordRequest,
  IForgotPasswordResponse,
  IResetPasswordRequest,
  IResetPasswordResponse,
} from "../common/types";

const JULEB_DOMAIN = window.location.host;

const GRAPHQL_SERVICE = process.env.REACT_APP_GRAPHQL_SERVICE || "auth_graphql";
export const endpoint =
  process.env.REACT_APP_GRAPHQL_ENDPOINT ||
  `${
    JULEB_DOMAIN.includes("localhost") ? "http" : "https"
  }://${JULEB_DOMAIN}/${GRAPHQL_SERVICE}`;

export const julebHttp = axios.create({
  baseURL: endpoint,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * On localhost the hostname carries no tenant, so the db has to be entered by
 * hand and sent in the request body. The server half of this lives in
 * auth-graphql src/common/tenant.ts and is gated on NODE_ENV=local; keep the two
 * halves in sync.
 */
export function isLocalHost(): boolean {
  return window.location.hostname === "localhost";
}

export async function logout() {
  return axios.post(AUTH_API.LOGOUT, {}, { withCredentials: true });
}

export async function requestPasswordReset(payload: IForgotPasswordRequest) {
  return axios.post<IForgotPasswordResponse>(
    AUTH_API.FORGOT_PASSWORD,
    {
      username: payload.username,
      db: isLocalHost() ? payload.db : undefined,
      lang: payload.lang,
    },
    { withCredentials: true },
  );
}

export async function resetPassword(payload: IResetPasswordRequest) {
  return axios.post<IResetPasswordResponse>(AUTH_API.RESET_PASSWORD, payload, {
    withCredentials: true,
  });
}

/**
 * Pulls the machine error code out of a failed auth call so the caller can pick
 * its own translated message. Returns undefined for network errors and for
 * responses that carry no code.
 */
export function getAuthErrorCode(error: unknown): AUTH_ERROR_CODE | undefined {
  if (!axios.isAxiosError(error)) {
    return undefined;
  }
  const code = (error.response?.data as { code?: string } | undefined)?.code;
  return code && code in AUTH_ERROR_CODE
    ? (code as AUTH_ERROR_CODE)
    : undefined;
}
